<template>
  <b-col sm="12" lg="12">
    <div class="animated fadeIn">
      <b-card ref="cardRef" class="backClass">
        <div style="height: 400px; padding-top: 150px" v-if="loadingData" class="loading">
          <b-row>
            <b-col lg="12">
              <div class="sk-double-bounce">
                <div class="sk-child sk-double-bounce1"></div>
                <div class="sk-child sk-double-bounce2"></div>
              </div>
            </b-col>
          </b-row>
        </div>
        <div v-else>
          <h4 style="display:inline-block">All locations</h4>
          <b-form-input
            style="display:inline-block; width:250px;float:right"
            v-model="searchQuery"
            type="search"
            id="filterInput"
            placeholder="Type to Search"
          ></b-form-input>

          <hr />
          <b-row>
            <template v-for="location in filterItems(locations)">
              <b-col lg="3" sm="6" :key="location.id" style="padding: 5px;">
                <a
                  class="locationLabels"
                  :href="'#/base/city/?loc=' + location.id + '&city=' + location.locaton + '&lat=' + location.lat + '&lng=' + location.lng"
                >{{location.locaton}}</a>
              </b-col>
            </template>
          </b-row>
        </div>
      </b-card>
    </div>
  </b-col>
</template>


<script>
export default {
  name: "ProfileLocations",
  components: {},
  props: ["locationData"],
  data() {
    return {
      searchQuery: "",
      loadingData: true,
      locations: []
    };
  },
  methods: {
    fetchLocations() {
        this.$http.get("api/tec/profile/alphaLocations.php", {
        })
        .then(
          res => {
            console.log(res.data)
            this.locations = res.data.records;
            this.loadingData = false;
          },
          err => {
            console.log(err);
            this.loading = false;
          }
        );
    },
    filterItems: function(locations) {
      var app = this;
      return locations.filter(function(location) {
        let regex = new RegExp("(" + app.searchQuery + ")", "i");
        return location.locaton.match(regex);
      });
    }
  },
  mounted() {
    this.fetchLocations();
    this.loadingData = false;
  }
};
</script>

<style scoped>
.locationLabels {
  padding: 9px;
}
</style>
